// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import Dashboard from "./Dashboard";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import MembersLogin from "./MembersLogin";
import MembersDashboard from "./MembersDashboard";
import OfferPage from "./OfferPage";
import "./index.css";
import ResetPassword from "./ResetPassword";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      {/* 🏠 Public homepage */}
      <Route path="/" element={<LandingPage />} />

      {/* 🔐 Firebase login */}
      <Route path="/login" element={<Login />} />

      {/* 🧪 Internal agent dashboard (login required) */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* 🧑‍💼 Members login page */}
      <Route path="/members" element={<MembersLogin />} />

      {/* 🔐 Premium dashboard (must be subscribed) */}
      <Route
        path="/membersdashboard"
        element={
          <ProtectedRoute requireSubscription={true}>
            <MembersDashboard />
          </ProtectedRoute>
        }
      />

      {/* 💥 Non-member value prop + checkout */}
      <Route path="/offer" element={<OfferPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  </BrowserRouter>
);
